"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPassword = void 0;
const react_native_1 = require("react-native");
const ForgotPassword_style_1 = require("./ForgotPassword.style");
const react_1 = __importStar(require("react"));
const atome_1 = require("../../atome");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const organisms_1 = require("../../organisms");
const Breakpoints_1 = require("../../../helper/Breakpoints");
// @ts-ignore
function ForgotPassword({ navigation }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const [email, setEmail] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [success, setSuccess] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (auth.isAuthenticated) {
            navigation.navigate('Dashboard');
        }
        return () => { };
    }, [auth.isAuthenticated]);
    const forgotPassword = async () => {
        setError('');
        const forgotData = {
            email: email,
        };
        const response = await User_service_1.default.forgotPassword(forgotData);
        if (!response.error) {
            setEmail('');
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
                navigation.navigate('Login');
            }, 3000);
        }
        if (response.error) {
            setError('error');
            if (response.message.response?.data?.error) {
                setError('email');
            }
            console.log(response.message);
        }
    };
    const emailFieldOnChange = (fieldText) => {
        setEmail(fieldText);
        setError('');
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, { style: [!Breakpoints_1.isDesktop && ForgotPassword_style_1.styles.view, { backgroundColor: 'white' }] },
        react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
        react_1.default.createElement(react_native_1.View, { style: ForgotPassword_style_1.styles.container },
            react_1.default.createElement(atome_1.Label, { style: [ForgotPassword_style_1.styles.firstLabel] }, "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort neu zu setzen."),
            react_1.default.createElement(react_native_1.View, { style: ForgotPassword_style_1.styles.inputContainer },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.Label, null, "E-Mail-Adresse")),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.InputField, { onChange: (text) => emailFieldOnChange(text), value: email, style: [ForgotPassword_style_1.styles.input], onKeyPress: event => event.nativeEvent.key === 'Enter' ? forgotPassword() : null })),
                error === 'email' && (react_1.default.createElement(atome_1.Text, { style: [ForgotPassword_style_1.styles.error] }, "Die E-Mail-Adresse ist falsch.")),
                error === 'error' && (react_1.default.createElement(react_native_1.View, { style: ForgotPassword_style_1.styles.row },
                    react_1.default.createElement(atome_1.Text, { style: [ForgotPassword_style_1.styles.error] }, "Es ist ein Fehler aufgetreten, versuchen Sie es bitte erneut.")))),
            success && (react_1.default.createElement(react_native_1.View, { style: ForgotPassword_style_1.styles.saveMessageContainer },
                react_1.default.createElement(atome_1.Text, { style: [ForgotPassword_style_1.styles.saveMessageText] }, "Erfolgreich"))),
            react_1.default.createElement(react_native_1.View, { style: [ForgotPassword_style_1.styles.buttonContainer] },
                react_1.default.createElement(react_native_1.Pressable, { style: ForgotPassword_style_1.styles.button, onPress: forgotPassword },
                    react_1.default.createElement(atome_1.Text, { style: [ForgotPassword_style_1.styles.buttonText] }, "Neues Passwort anfordern")),
                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(react_native_1.Pressable, { style: ForgotPassword_style_1.styles.marginTop20, onPress: () => navigation.navigate('Login') },
                    react_1.default.createElement(atome_1.Text, { style: [ForgotPassword_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))))));
}
exports.ForgotPassword = ForgotPassword;
